export interface HomeLobbyState {
    activeComponent: HomeLobbyComponent;
}

export interface HomeLobbyComponent {
    componentId: HomeLobbyComponentId;
}

export const HOME_LOBBY_COMPONENT_INIT: HomeLobbyComponent = {
    componentId: 'sweepstakes-banner',
}

export type HomeLobbyComponentId = 'sweepstakes-banner' | 'sweepstakes' | 'freeplay-banner' | 'freeplay' | 'club-list-banner' | 'club-list' | 'club-list-no-animation' | 'pending-requests-list' |'quickplay-banner' | 'quickplay' | 'old-lobby-home' | 'lobby-home';

export const HOME_LOBBY_INIT_STATE: HomeLobbyState = {
    activeComponent: {...HOME_LOBBY_COMPONENT_INIT},
};
